<template>
  <div class="log">
    <header-back
      :title="myLabel"
      @back="toBack"
    />
    <cube-loading
      v-if="loadingContent"
      :size="40"
    />
    <div
      v-if="!loadingContent"
      class="work_log"
    >
      <my-textarea
        v-if="isDingding"
        :data="editData"
        height="calc(100vh - 140px)"
        @change="getEditorContent"
      />
      <editor
        v-else
        :data="editData"
        :height="667"
        class="edit_container"
        @change="getEditorContent"
      />
    </div>
    <div class="log_sub_btn_main">
      <cube-button
        :disabled="addComplete"
        @click="toAddWorkLogo"
      >
        {{ $t('message["21"]') }}
      </cube-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Editor from '@/components/mobile/formItem/Editor1'
import MyTextarea from '@/components/mobile/formItem/Textarea'
import headerBack from '@/components/mobile/HeaderBack'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    headerBack,
    Editor,
    MyTextarea
  },
  data () {
    return {
      editorContent: {}
    }
  },
  computed: {
    ...mapState('record', ['preWorkLogo', 'addComplete', 'loadingContent']),
    ...mapState(['baseinfo']),
    editData () {
      return Object.assign({}, { fieldvalue: this.preWorkLogo.content })
    },
    isDingding () {
      let ua = navigator.userAgent
      let isDingDing = (/DingTalk/.test(ua) && window.innerWidth < 500)
      return isDingDing
    },
    myLabel () {
      return this.$t('message["1273"]')
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = this.$t('message["1273"]') + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  async created () {
    await this.getWorkLogoInfo()
  },
  methods: {
    ...mapActions('record', ['addWorkLog', 'getWorkLogoInfo']),
    getEditorContent (value) {
      this.editorContent = { content: value }
    },
    toAddWorkLogo () {
      this.$bus.$emit('myQuillEditorBlur')
      const { content } = this.editorContent
      if (content === '') {
        this.$selefToast({ type: 'error', text: this.$t('message["661"]') })
      } else {
        this.addLog(this.editorContent)
      }
    },
    toBack () {
      this.$router.push({ name: 'ProjectIndex' })
    },
    async addLog (data) {
      const chain = await this.addWorkLog()
      chain.params(data)
        .onSuccess((res, result) => {
          const { message } = result
          this.$selefToast({ text: message })
        })
        .onFail((err) => {
          this.$selefToast({ type: 'error', text: err })
        })
        .fetch()
    }
  }
}
</script>

<style scoped lang="scss">
.log::v-deep {
  overflow: hidden;
  .work_log {
    background: #fff;
    .edit_container {
      .quill-editor {
        .ql-container {
          height: calc(459px) !important;
        }
      }
    }
  }
  .log_sub_btn_main {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 62px;
    background: #fff;
    display: flex;
    button {
      width: 95%;
      margin: auto;
      background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
      box-shadow:0px 2px 2px 0px rgba(255,255,255,0.5);
    }
  }
}
</style>
